module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Mettre l’article en pause',
        mainHeader: 'Êtes-vous certain de vouloir mettre en pause votre réapprovisionnement automatique? Vous pouvez reprendre à tout moment.',
        pause: 'En pause',
        cancel: 'Annuler',
        item: 'ARTICLE',
        qty: 'Qté',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        yearlySavings: 'économies annuelles'
    };

    return resources[label];
};
